import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
    SetOrdered,
    SetUnordered,
    WithIconContainer,
    WithIconPadding,
    WithIconFlex,
} from './style'
import Icon from '@components/Icon'

const List = (props) => {
    const { ordered, unordered, withIcon, icon, items } = props

    const orderedClassNames = classNames(SetOrdered)
    const unorderedClassNames = classNames(SetUnordered)
    const withIconContainer = classNames(WithIconContainer)
    const withIconPadding = classNames(WithIconPadding)
    const withIconFlex = classNames(WithIconFlex)

    return (
        <Fragment>
            {ordered && (
                <ol className={orderedClassNames}>
                    {items.map((item, key) => {
                        return (
                            <li
                                className={'py-[5.5px] pl-[3px]'}
                                key={key}
                                dangerouslySetInnerHTML={{
                                    __html: item,
                                }}
                            ></li>
                        )
                    })}
                </ol>
            )}
            {unordered && (
                <ul className={unorderedClassNames}>
                    {items.map((item, key) => {
                        return (
                            <li
                                className={'py-[5.5px] pl-[3px]'}
                                key={key}
                                dangerouslySetInnerHTML={{
                                    __html: item,
                                }}
                            ></li>
                        )
                    })}
                </ul>
            )}
            {withIcon && (
                <ul className={withIconContainer}>
                    {items.map((item, key) => {
                        return (
                            <li key={key} className={withIconFlex}>
                                <span>{icon && <Icon icon={icon} />}</span>
                                <span className={withIconPadding}>{item}</span>
                            </li>
                        )
                    })}
                </ul>
            )}
        </Fragment>
    )
}

List.propTypes = {
    ordered: PropTypes.bool,
    unordered: PropTypes.bool,
    withIcon: PropTypes.bool,
    icon: PropTypes.string,
    list: PropTypes.array,
}

export default List
